export * from './DetailsList'
export { default as DetailsList } from './DetailsList'
